import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => (
    <div className="text-center py-5">
        <i className="bi bi-compass display-1 text-body-secondary" />
        <h3 className="mt-3">Pagina non trovata</h3>
        <p className="text-body-secondary">L'URL richiesto non esiste in questa area.</p>
        <Link to="/dashboard" className="btn btn-primary">
            <i className="bi bi-house me-2" />
            Torna alla dashboard
        </Link>
    </div>
);

export default NotFoundPage;
